//import Swal from "sweetalert2";
//import Vue from "vue";
import {
    addCompanyBranch, addCompanyWarehouse,
    deleteCompanyBranch, deleteCompanyWarehouse,
    getBranchList,
    getCompanyBranchList, getCompanyWarehouseList,
    getList, updateCompanyBranch, updateCompanyWarehouse,getERPWarehouseList
} from "@/services/modules/company/companyService";
import {showProcessErrorMessage, showProcessPromptMessage, showProcessSuccessMessage} from "@/state/alertHelpers";

export const state = {
    companyList: [],
    companyListHeaders: [],
    companyListLoading: false,
    branchList: [],
    companyBranchList: [],
    companyBranchListHeaders: [],
    companyBranchListLoading: false,
    companyWarehouseList: [],
    companyWarehouseListHeaders: [],
    companyWarehouseListLoading: false,
    erpWarehouseList: [],

};

export const mutations = {
    setCompanyList(state, data) {
        state.companyList = data;
    },
    setCompanyListHeaders(state, data) {
        state.companyListHeaders = data;
    },
    setCompanyListLoading(state, data) {
        state.companyListLoading = data;
    },
    setBranchList(state, data) {
      state.branchList = data;
    },
    setCompanyBranchList(state, data) {
        state.companyBranchList = data;
    },
    setCompanyBranchListHeaders(state, data) {
        state.companyBranchListHeaders = data;
    },
    setCompanyBranchListLoading(state, data) {
        state.companyBranchListLoading = data;
    },
    setCompanyWarehouseList(state, data) {
        state.companyWarehouseList = data;
    },
    setCompanyWarehouseListHeaders(state, data) {
        state.companyWarehouseListHeaders = data;
    },
    setCompanyWarehouseListLoading(state, data) {
        state.companyWarehouseListLoading = data;
    },
    setErpWarehouseList(state, data) {
        state.erpWarehouseList = data;
    },
}

export const getters = {};

export const actions = {

    async fetchCompanyList(context, {params, body}) {

        let result = await getList(params, body)
        if(result.data.success){
            context.commit("setCompanyList",result.data.data);
        }
        return result.data.data;

    },

    async fetchBranchList(context, {params, body}) {

        let result = await getBranchList(params, body)
        if(result.data.success){
          context.commit("setBranchList",result.data.data);
        }
        return result.data.data;

    },

    async fetchCompanyBranchList(context, {params, body}) {
        context.commit("setCompanyBranchListLoading",true);
        context.commit("setCompanyBranchListHeaders",[
            {
                key: "name",
                label: "Şube Adı",
                class: "text-center align-middle",
            },
            {
                key: "erpCode",
                label: "ERP Kodu",
                class: "text-center align-middle",
            },
            {
                key: "isActive",
                label: "Durum",
                class: "text-center align-middle",
            },
            {
                key: "process",
                label: "İşlem",
                sortable: false,
                class: "text-center",
            },
        ]);
        let result = await getCompanyBranchList(params, body)
        if(result.data.success){
          context.commit("setCompanyBranchList",result.data.data);
        }
        context.commit("setCompanyBranchListLoading",false);
        return result.data.data;
    },

    async companyBranchAdd(context, {params, body}) {
        context;
        let result = await addCompanyBranch(params, body);

        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.message,
            }).then(() => {
                context.dispatch("fetchCompanyBranchList", {
                    params: {},
                    body: {},
                });
            });
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },

    async companyBranchUpdate(context, {params, body}) {
        context;
        let result = await updateCompanyBranch(params, body);

        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.message,
            }).then(() => {
                context.dispatch("fetchCompanyBranchList", {
                    params: {},
                    body: {},
                });
            });
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },

    async companyBranchDelete(context, { params, body, urlSegments }) {
        context;
        showProcessPromptMessage({
            title: 'Şube  Silinecek',
            text: "Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz ?",
        }).then(async function (confirm) {
                if (confirm.isConfirmed) {

                    let result = await deleteCompanyBranch(params, body,urlSegments);
                    if (result.data.success) {
                        showProcessSuccessMessage({
                            title: 'İşlem Başarılı',
                            text: result.data.message
                        })
                        await context.dispatch("fetchCompanyBranchList", {
                            params: {},
                            body: {}
                        })
                    }
                    else
                        showProcessErrorMessage({
                            title: 'İşlem Başarısız',
                            text: result.data.message
                        })

                    return result;
                }
            }
        )
    },
    async fetchCompanyWarehouseList(context, {params, body}) {
        context.commit("setCompanyWarehouseListLoading",true);
        context.commit("setCompanyWarehouseListHeaders",[
            {
                key: "name",
                label: "Şube Adı",
                class: "text-center align-middle",
            },
            {
                key: "erpCode",
                label: "ERP Kodu",
                class: "text-center align-middle",
            },
            {
                key: "isActive",
                label: "Durum",
                class: "text-center align-middle",
            },
            {
                key: "process",
                label: "İşlem",
                sortable: false,
                class: "text-center",
            },
        ]);
        let result = await getCompanyWarehouseList(params, body)
        if(result.data.success){
          context.commit("setCompanyWarehouseList",result.data.data);
        }
        context.commit("setCompanyWarehouseListLoading",false);
        return result.data.data;
    },
    async companyWarehouseAdd(context, {params, body}) {
        context;
        let result = await addCompanyWarehouse(params, body);

        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.message,
            }).then(() => {
                context.dispatch("fetchCompanyWarehouseList", {
                    params: {},
                    body: {},
                });
            });
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },
    async companyWarehouseUpdate(context, {params, body}) {
        context;
        let result = await updateCompanyWarehouse(params, body);

        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.message,
            }).then(() => {
                context.dispatch("fetchCompanyWarehouseList", {
                    params: {},
                    body: {},
                });
            });
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },
    async companyWarehouseDelete(context, { params, body,urlSegments }) {
        context;
        showProcessPromptMessage({
            title: 'Şube  Silinecek',
            text: "Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz ?",
        }).then(async function (confirm) {
                if (confirm.isConfirmed) {

                    let result = await deleteCompanyWarehouse(params, body,urlSegments);
                    if (result.data.success) {
                        showProcessSuccessMessage({
                            title: 'İşlem Başarılı',
                            text: result.data.message
                        })
                        await context.dispatch("fetchCompanyWarehouseList", {
                            params: {},
                            body: {}
                        })
                    }
                    else
                        showProcessErrorMessage({
                            title: 'İşlem Başarısız',
                            text: result.data.message
                        })

                    return result;
                }
            }
        )
    },

    async fetchErpWarehouseList(context, {params, body}) {
        let result = await getERPWarehouseList(params, body)
        if(result.data.success){
          context.commit("setErpWarehouseList",result.data.data);
        }
        return result.data.data;
    }
};
  